export default class DASignatureModel {
    constructor(
        file
    ) {
        this.file = file ? file : ''
    }
}